import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SuperuserGuard } from './superuser.guard';
import { SessionService } from '../_services/session/session.service';
import { BaseComponent } from '../components/base/base.component';
import ICustomer from '../_interfaces/ICustomer';

@Injectable({
  providedIn: 'root',
})
export class IsAdminGuardGuard extends BaseComponent {
  constructor(
    public session: SessionService,
    private superuserGuard: SuperuserGuard,
    private router: Router,
  ) {
    super(session);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const rawCustomerParam = `${next.params['customers_id'] ?? ''}`.trim();
    const isAdminRoute = state.url.startsWith('/administration/');
    const requiresScopedCustomer = !!next.routeConfig?.path?.includes(':customers_id');

    if (isAdminRoute && requiresScopedCustomer && !rawCustomerParam) {
      return this.router.parseUrl('/administration');
    }

    if (this.session.isSuperUser()) {
      return true;
    }

    const parsedCustomerId = Number(rawCustomerParam);
    const hasNumericCustomerId = Number.isFinite(parsedCustomerId) && parsedCustomerId > 0;

    const customerRef = {
      ...(hasNumericCustomerId
        ? { id: parsedCustomerId }
        : { identifier: rawCustomerParam }),
    } as ICustomer;

    const isCustomerAdmin = this.session.isCustomerAdmin(customerRef);

    if (isCustomerAdmin) {
      return true;
    }

    return this.superuserGuard.canActivate(next, state);
  }
}
